import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    estatusInformeAlcance: [],
  },

  getters: {
    getEstatusInformeAlcance: (state) => state.estatusInformeAlcance,
  },

  mutations: {
    SET_ESTATUS_INFORME_ALCANCE(state, estatusInformeAlcance) {
      state.estatusInformeAlcance = estatusInformeAlcance;
    },
  },

  actions: {
    async fetchEstatusInformeAlcance({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catEstatusInformeAlcance')
        .then((response) => {
          commit('SET_ESTATUS_INFORME_ALCANCE', response.data.data);
        });
    },
  },
};
